import styled from 'styled-components';
import {spacing} from '@propellerads/stylevariables';
import {SIZE, COLOR} from './types';

interface StyledIconProps {
  size: SIZE
  color: COLOR | string
  hoverColor: COLOR | string
}

const StyledIcon = styled.svg`
  display: inline-flex;

  // SIZE
  ${(props: StyledIconProps) => props.size === SIZE.EXTRA_SMALL && `
    width: ${spacing * 3}px;
    height: ${spacing * 3}px;
  `}
    
  ${(props: StyledIconProps) => props.size === SIZE.SMALL && `
    width: ${spacing * 4}px;
    height: ${spacing * 4}px;
  `}
  
  ${(props: StyledIconProps) => props.size === SIZE.MEDIUM_SMALL && `
    width: ${spacing * 5}px;
    height: ${spacing * 5}px;
  `}
  
  ${(props: StyledIconProps) => props.size === SIZE.MEDIUM && `
    width: ${spacing * 6}px;
    height: ${spacing * 6}px;
  `}
  
  ${(props: StyledIconProps) => props.size === SIZE.LARGE && `
    width: ${spacing * 8}px;
    height: ${spacing * 8}px;
  `}
  
  ${(props: StyledIconProps) => props.size === SIZE.EXTRA_LARGE && `
    width: ${spacing * 16}px;
    height: ${spacing * 16}px;
  `}
  
  // COLORS
  ${(props: StyledIconProps) => props.color && `
    fill: ${props.color};
  `}
  
  ${(props: StyledIconProps) => props.hoverColor && `
    &:hover {
      fill: ${props.hoverColor};
    }
  `}
`;

export {StyledIcon};
